import { createContext, FC, useContext, useEffect } from 'react';
import { getUnreadNewsItemCounts } from '../fetch';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';
import { UserContext } from '../context';

interface INewsNotificationContext {
  unreadNewsItemCount: number;
  getUnreadNewsItemCount: () => void;
  isLoadingCount: boolean;
}

export const NewsNotificationContext = createContext<INewsNotificationContext>({
  unreadNewsItemCount: 0,
  getUnreadNewsItemCount: () => {},
  isLoadingCount: false
});

interface INewsNotificationContextHandlerProps {}

export const NewsNotificationContextHandler: FC<INewsNotificationContextHandlerProps> = ({
  children
}): JSX.Element => {
  const { user } = useContext(UserContext);

  const {
    isLoading,
    data: unreadNewsItemCount,
    refetch: refetchUnreadNewsItemCount
  } = useQuery<number, Error>(['getUnreadNewsItemCounts'], () => getUnreadNewsItemCounts(), {
    notifyOnChangeProps: 'tracked',
    enabled: user !== undefined
  });
  const location = useLocation();

  useEffect(() => {
    if (user !== undefined) refetchUnreadNewsItemCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, user]);

  return (
    <NewsNotificationContext.Provider
      value={{
        unreadNewsItemCount,
        getUnreadNewsItemCount: refetchUnreadNewsItemCount,
        isLoadingCount: isLoading
      }}
    >
      {children}
    </NewsNotificationContext.Provider>
  );
};
